import React from 'react';
import './App.css';
import Footer from './Components/Footer/Footer';
import NavBar from './Components/NavBar/NavBar';
import Project from './Components/Project/Project';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import Home from './Components/Home/Home';
import Services from './Components/Service/Services'
import About from './Components/About/About'
import ScrollToTop from './Components/ScrollToTop';

function App() {
  return (
    <BrowserRouter>
      <NavBar />
      <ScrollToTop/>
      <Routes>
        <Route exact path='/' element={<Home/>} />
        <Route path='/project' element={<Project/>} />
        <Route path='/home' element={<Home/>} />
        <Route path='/service' element={<Services/>} />
        <Route path='/about' element={<About/>} />
        <Route path='*' element={<Home/>}/>
      </Routes>
      
      <Footer />
    </BrowserRouter>
  );
}

export default App;
